import { GenerateProposalDocumentsClientRequest } from '../../../@types/GenerateProposalDocuments'
import { ENV } from '../../../Environment'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useAgent } from '../../../Stores/useAgent'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'

export const useGenerateProposalDocumentsPayload = () => {
  const { createProposal } = useCreateProposalStore()
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { runPetisSimulation, selectedPackCampaign } =
    useRunPetisSimulationStore()
  const { agentIdBySessionStorage } = useAgent()

  const generateProposalPayload: GenerateProposalDocumentsClientRequest = {
    accessType: 'S', //TODO: Hardcoded
    agentCode: agentIdBySessionStorage || '',
    applicationCode: ENV().ApplicationCode,
    branchCode: ENV().GenerateProposalDocuments.BranchCodeGenerateProposal, //TODO: Review
    campaignId: (selectedPackCampaign?.coverages || [])?.length
      ? selectedPackCampaign?.campaignId
      : '',
    companyCode: ENV().GenerateProposalDocuments.CompanyCodeGenerateProposal, //TODO: Review
    coreSystem: ENV().CoreSystem,
    entityId: policyholderDetailsSelected?.idEntity || '',
    lineOfBusinessCode:
      runPetisSimulation?.runPetisSimulationResponse?.productData
        ?.lineofBusiness?.lineofBusinessID || '',
    simulationId: runPetisSimulation?.runPetisSimulationResponse?.quoteId || '',
    policyId: createProposal?.createProposalResponse?.proposalId || '',
    productCode: `${ENV().ProductCode}${ENV().ProductCodeVersion}`,
    vatNumber: policyholderDetailsSelected?.vatNumber || '',
    productFamilyId:
      runPetisSimulation?.runPetisSimulationResponse?.productData
        ?.lineofBusiness?.productFamilyID || '',
    originTemplate: 'PTL', // TODO: hardcoded
    segmentCode:
      runPetisSimulation?.runPetisSimulationResponse?.productData?.segment
        ?.segmentCode || '',
  }

  return {
    generateProposalPayload,
  }
}
